module.exports={
    logout  : "Cuenta de cancelación",
    my      :'Mío',
    scqx    :'Eliminar permisos',
    qxgl    :'Gestión de permisos',
    qdzxzhm :'¿Está seguro de cancelar la cuenta?',
    qtxkh   :'Por favor, rellene el número de tarjeta',
    qd      :'Determinar',
    qx      :'Cancelar',
    gb      :'Cerrar',
    kh      :'Número de tarjeta',
    kmewm   :'Código bidimensional de apertura de puertas',
    dl      :'Iniciar sesión',
    name    :'Nombre de usuario',
    qtxname :'Por favor, rellene el nombre de usuario',
    pwas    :'Contraseña',
    qtxpwas :'Por favor, rellene la contraseña',
    tj      :'Submission',
    zczh    :'Número de cuenta registrado',
    zc      :'Registro',
    sjhm    :'Número de teléfono móvil',
    qtxsjhm :'Por favor, rellene el número de teléfono móvil',
    yzm     :'Código de verificación',
    qtxyzm  :'Por favor, rellene el Código de verificación',
    yyzhqqdl:'Cuenta existente, inicie sesión',
    hqyzm   :'Obtener Código de verificación',
    zccg    :'Registro exitoso',
    zcsb    :'Falló el registro',
    fscg    :'Enviar con éxito',
    fssb    :'Falló el envío',
    yhycz   :'El usuario ya existe',


    xgmm    : "Cambiar contraseña",
    zhmm    :'Recuperar contraseña',
    qrmm    :'Confirmar contraseña',
    zhyxmm  :"Recuperar buzón de correo con contraseña",
    yxyzm   :'Código de verificación del buzón de correo',
    hqyxyzm :'Obtener el Código de verificación del buzón de correo',
    zzmmyx  :'Restablecer buzón de contraseña',
    lcmmbyc :'Dos contraseñas inconsistentes',
    xgcg    :'Modificación exitosa',
    xgsb    :'Modificación fallida',
    qtxyxyx  :'Por favor, rellene un correo electrónico válido',
    lsmhhq  :'Recuperación en 60 segundos',
    hqyyyzmcg:'Obtener el Código de verificación del buzón de correo con éxito',
    zhmmbd  :'Contraseña de cuenta incorrecta'
}